import { render } from "./AttributeInput.vue?vue&type=template&id=e2d5fbe0&scoped=true&ts=true"
import script from "./AttributeInput.vue?vue&type=script&lang=ts"
export * from "./AttributeInput.vue?vue&type=script&lang=ts"

import "./AttributeInput.vue?vue&type=style&index=0&id=e2d5fbe0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d5fbe0"]])

export default __exports__